// @flow

import SiteLogo from './logo.svg';
import FeaturesAuth from './features-auth.svg';
import FeaturesBinders from './features-binders.svg';
import FeaturesList from './features-list.svg';
import SolutionsSpBinder from './solutions-spbinder.svg';
import Solutions1040Scan from './solutions-1040scan.svg';
import SolutionsTaxCaddy from './solutions-taxcaddy.svg';
import SolutionsOutsource from './solutions-outsource.svg';
import SignIn from './signin.svg';
import Signup from './signup.svg';
import Step1 from './Step1.png'
import Step2 from './Step2.png'
import Step3n from './Step3-n.png'
import Step4n from './Step4-n.png'
import Step3 from './Step3.png'
import Step4 from './Step4.png'
import Step5 from './Step5.png'
import Step6 from './Step6.png'
import Step7 from './Step7.png'
import Step8 from './Step8.png'
import Step9 from './Step9.png'
import AccountDetails from './icon-account-details.png';

const Images = {
    Logo: {
        Path: SiteLogo,
        Alt: 'Logo'
    },
    FeaturesAuth: {
        Path: FeaturesAuth,
        Alt: 'Authentication'
    },
    FeaturesBinders: {
        Path: FeaturesBinders,
        Alt: 'Binders'
    },
    FeaturesList: {
        Path: FeaturesList,
        Alt: 'Lists'
    },
    SolutionsSpBinder: {
        Path: SolutionsSpBinder,
        Alt: 'SP Binder'
    },
    Solutions1040Scan: {
        Path: Solutions1040Scan,
        Alt: '1040 Scan'
    },
    SolutionsTaxCaddy: {
        Path: SolutionsTaxCaddy,
        Alt: 'TaxCaddy'
    },
    SolutionsOutsource: {
        Path: SolutionsOutsource,
        Alt: 'Outsource'
    },
    SignIn: {
        Path: SignIn,
        Alt: 'SignIn'
    },
    Signup: {
        Path: Signup,
        Alt: 'Signup'
    },
    Step1: {
        Path: Step1,
        Alt: 'Step1'
    },    
    Step2: {
        Path: Step2,
        Alt: 'Step2'
    },
    Step3: {
        Path: Step3,
        Alt: 'Step1'
    },
    Step4: {
        Path: Step4,
        Alt: 'Step2'
    },
    Step3n: {
        Path: Step3n,
        Alt: 'Step3'
    },
    Step4n: {
        Path: Step4n,
        Alt: 'Step4'
    },
    Step5: {
        Path: Step5,
        Alt: 'Step3'
    },
    Step6: {
        Path: Step6,
        Alt: 'Step4'
    },
    Step7: {
        Path: Step7,
        Alt: 'Step5'
    },
    Step8: {
        Path: Step8,
        Alt: 'Step6'
    },
    Step9: {
        Path: Step9,
        Alt: 'Step7'
    },
    AccountDetails: {
        Path: AccountDetails,
        Alt: 'AccountDetails'
    }

    
};

export default Images;



